import { useNavigate } from 'react-router-dom';

import { Menu, rem } from '@mantine/core';

import { AppRoutes } from '@/router/routes.ts';

import { IconFile, IconFileInfo, IconIdBadge2, IconScan } from '@tabler/icons-react';

export const AdminSection = () => {
	const navigate = useNavigate();

	return (
		<>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconIdBadge2 style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.Passes)}
			>
				Пропуска
			</Menu.Item>

			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconScan style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.PassTypes)}
			>
				Типы пропусков
			</Menu.Item>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconFile style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.Vocabulary)}
			>
				Типы объектов
			</Menu.Item>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconFileInfo style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.References)}
			>
				Справки
			</Menu.Item>
		</>
	);
};
